import _get from 'lodash/get';
import properties from '../modules/ajio-util/properties';
import { errorProcessor } from '../modules/ajio-fetch/errorProcessor';
import fetcher from '../modules/ajio-fetch';
import { getFeatureVariant } from '../refresh/organism/ABFeature/Feature';

import { fetchGetJSONReqOpts, fetchGetJSONResHandler } from '../modules/ajio-fetch/utils';
import * as ga from '../modules/ga';

import { readCookie, readCohortValueCookie } from '../components/common/Cookie';
import { getUserCohortIds } from './products';
import { getBundleBannerImpressionArray } from './jioAdsRelated';
import { gtmPromotionCmsImpressions } from '../modules/ga/GTMdatalayer';
import { getCookieConfig } from './cookieConfig';
import { getAmplitudeVariantPayload } from '../utils/amplitudeCommon';

const hashKeys = ['userStatus', 'userType', 'city', 'state', 'zone', 'pcGroup'];

const endpoints = require('../modules/ajio-util/endpoints');


export function readCohortValueV1(userCohortValue, storeval, serviceName, enableUniversalCohortFlow = false) {
  const newStoreval = storeval ? `${storeval}_v1` : 'rilfnl_v1';
  let cohortValue;

  if (Array.isArray(userCohortValue)) {
    userCohortValue?.forEach(element => {
      const { key, value } = element;
      if (!storeval && key === 'rilfnl_v1') {
        cohortValue = value;
      } else if (newStoreval && newStoreval === key) {
        cohortValue = value;
      }
    });
  } else {
    if(enableUniversalCohortFlow) {
      cohortValue = userCohortValue?.[serviceName]?.cohorts || '';
      console.log('COHORT VALUE', cohortValue);
    } else{
      cohortValue = userCohortValue?.[newStoreval]?.[serviceName]?.cohorts || ''; //TODO: Null check gives problem with array
    }
  }

  return cohortValue;
}

const getHash = params =>
  hashKeys.reduce((acc, key) => {
    if (params[key]) {
      return `${acc}:${key}_${params[key]}`;
    }
    return acc;
  }, '');

export function updateRuntimeData(request, req, res) {
  let { store, headers = {} } = req;
  const { sisname } = headers;
  if (!store && sisname) store = sisname;
  const { query = {} } = request;
  if (!store && query?.store) store = query.store;
  store = store ? store.toUpperCase() : 'AJIO';
  const userAgent = req.headers['user-agent'];
  const device = req.device.type;
  const segmentIds = query?.segmentIds ? query?.segmentIds : null;
  const storeval = store.toLowerCase() === 'ajio' || store.toLowerCase() === 'rilfnl' ? '' : store;
  let { customerValueType, enableRushDelivery, enableUniversalCohortFlow=false } = request;
  const cohortValue = getUserCohortIds(req, storeval, false, 'cms', enableUniversalCohortFlow);
  const { PC: pincode = '' } = req?.cookies || {};
  const pincodeObj = enableRushDelivery && pincode ? { pincode } : {};

  if (cohortValue) customerValueType = cohortValue.split('|')[0];

  const runtimeParams = {
    experiments: request.experiments,
    pageUrl: `${request.pageUrl}`,
    platform: request.platform,
    channel: request.channel,
    store,
    tenantId: 'AJIO',
    userStatus: !req.cookies.LS ? 'NON_LOGGED_IN' : 'LOGGED_IN',
    userType: request.customerType,
    city: request.city,
    state: request.state,
    zone: request.zone,
    pcGroup:
    request.pcGroup !== undefined && request.pcGroup !== null
      ? request.pcGroup
      : request.pincodeGroup !== undefined && request.pincodeGroup !== null
      ? request.pincodeGroup
      : '',
    segmentIds,
    ...pincodeObj,
    ...(request.userGroup && request.sendUserGroup ? { userGroup: request.userGroup } : {})
  };
  const hash = getHash(runtimeParams);
  res.setHeader('X-Cache-hash', hash);
  return {
    ...request,
    runtimeParams,
    userAgent,
    device,
    customerValueType
  };
}

// quries values
// const {
//   pageId,
//   platform,
//   tenantId,
//   timeStamp,
//   userStatus,
//   userType,
//   city,
//   state,
//   zone,
// } = req.query;
export function getPreviewOrArchiveData(request, req, res) {
  return {
    ...request,
    runtimeParams: {
      pageUrl: request.pageUrl,
      ...req.query,
      userType:
        request?.query?.userType || _get(request, 'jioAdsDefaultParam.userRestriction', 'new'),
      bufferTimeForPreview: _get(request, 'jioAdsDefaultParam.bufferTimeForPreview', 10)
    },
    userAgent: req.headers['user-agent'] || '',
    customerValueType:
      req?.query?.userGroup || _get(request, 'jioAdsSpecs.userGroup', 'non_premium')
  };
}

export function getConfigUrl() {
  return {
    domain: properties.getProperty('apiUrl'),
    subDomain: '/rilfnlwebservices/v2/rilfnl'
  };
}
export function getApiEndpoint(
  urlParameter = {},
  apiType = '',
  isUAAS = false,
  isNewCohortFlowEnabled = false,
  fetchDefaultAddress = false,
  enableUniversalCohortFlow=false
) {
  // Paramter should be object only
  const { domain = '', subDomain = '' } = getConfigUrl();
  const { customerId = '', latitude = '', longitude = '', storeval = '' } = urlParameter;
  const newStoreValue = storeval ? `${storeval}_v1` : 'rilfnl_v1';

  const APIObject = {
    customerTypeAPI() {
      if (fetchDefaultAddress) { 
        const uaasV3CustomerTypeApiEndpoint = enableUniversalCohortFlow ? endpoints.get('customerTypeUAASV4') : endpoints.get('customerTypeUAASV3');
        return `${uaasV3CustomerTypeApiEndpoint}&defaultAddress=true`;
      }
      if (isUAAS) {
        const endpointKey = enableUniversalCohortFlow ? 'customerTypeUAASV4' : (isNewCohortFlowEnabled ? 'customerTypeUAASV3' : 'customerTypeUAAS');
        const uaasCustomerTypeApiEndpoint = endpoints.get(endpointKey) || '';
        const [placeholder, replacement] = isNewCohortFlowEnabled
          ? ['STORE_NAME', newStoreValue]
          : ['CUSTOMER_ID', customerId];

        return uaasCustomerTypeApiEndpoint.replace(placeholder, replacement);
      }
      return `${domain}${subDomain}/users/${customerId}/customertype`;
    },
    userGeoLocationAPI() {
      return `${domain}${subDomain}/geoloc?latitude=${latitude}&longitude=${longitude}`;
    }
  };

  return APIObject[apiType]();
}

export function fetchRuntimeLocale({ pincode, latitude, longitude }) {
  return fetcher(
    endpoints.get('runtimeLocale'),
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ pincode, latitude, longitude })
    })
  )
    .then(fetchGetJSONResHandler)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

// Cross-platform function to calculate byte size
function getByteSize(obj) {
  const str = JSON.stringify(obj)
  if (typeof TextEncoder !== "undefined") {
      // ✅ Browser & Modern Node.js
      return new TextEncoder().encode(str).length;
  } else if (typeof Buffer !== "undefined") {
      // ✅ Node.js 10+ (Legacy support)
      return Buffer.byteLength(str, "utf8");
  } else {
      // ❌ Fallback (Very unlikely case)
     console.log("Your environment does not support TextEncoder or Buffer.");
  }
}

export async function fetchDeviceIdCohort(
  deviceID,
  res,
  req,
  storeValue,
  isFlagEnabled,
  isNewCohortFlowEnabled,
  userAuthInfo={},
  isMembershipPage = false,
  enableUniversalCohortFlow=false
) {
  //TODO: This is a temp code remove the code and return the below featch request. 
  let mockResponse = {
    status: {
      statusCode: 0
    },
    userSegmentIdSet: ['578'],
    userCohortValue: [
      {
        key: 'ajiogram_v1',
        value: 'deviceIdCohort|earlyaccess'
      },
      {
        key: 'luxe_v1',
        value: 'deviceIdCohort|earlyaccess'
      },
      {
        key: 'rilfnl_v1',
        value: 'deviceIdCohort|earlyaccess'
      }
    ]
  };
  const newMockResponse = {
    extraResponseParams: {},
    status: {
      errorArguments: [{}],
      errorCode: 'string',
      messageDescription: 'string',
      messageSubtext: 'string',
      statusCode: 0
    },
    userCohortValue: {
      rilfnl_v1: {
        cms: {
          cohorts: 'cms|earlyaccess'
        },
        plp: {
          cohorts: 'plp|earlyaccess'
        },
        pdp:{
          cohorts: 'pdp|earlyaccess'
        },
        wishlist:{
          cohorts:'wishlist|earlyaccess'
        }
      },
      luxe: {
        cms: {
          cohorts: 'cms|luxe-earlyaccess'
        },
        plp: {
          cohorts: 'plp|luxe-earlyaccess'
        },
        pdp:{
          cohorts: 'pdp|luxe-earlyaccess'
        },
        wishlist:{
          cohorts:'wishlist|luxe-earlyaccess'
        }
      }
    },
    userSegmentIdSet: ['578']
  };
  // const mockRequest = new Promise(resolve => {
  //   setTimeout(() => {
  //     resolve(newMockResponse);
  //   });
  // }, 500);
  const { token = null } = userAuthInfo || {};
  try {
    if (!isFlagEnabled || !token) {
      res.clearCookie('deviceCohortValue');
      return Promise.resolve()
    }
    if (!deviceID) {
      return Promise.resolve()
    }

    // const response = await mockRequest;
    const newStoreValue = storeValue ? `${storeValue}_v1` : 'rilfnl_v1';

    const endpointKey = enableUniversalCohortFlow ? 'deviceLevelCohortV3' : (isNewCohortFlowEnabled ? 'deviceLevelCohortV2' : 'deviceLevelCohort');
    const baseUrl = endpoints.get(endpointKey) + deviceID;
    const queryString = isNewCohortFlowEnabled && !enableUniversalCohortFlow ? `?store=${newStoreValue}` : '';

    const rawResp = await fetcher(
      baseUrl + queryString,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
          ad_id: deviceID,
          client_type: req.device.type === 'phone' ? 'MSITE' : 'WEB'
        }
      })
    );
    const response = await fetchGetJSONResHandler(rawResp);
    const { userCohortValue = null } = response;
    if(userCohortValue){
      // if the value is less than 1KB then we will set otherwise it can create problem with sending
      // cookies might exceed the limit
      if(getByteSize(userCohortValue) < 1024){
        res.cookie('deviceCohortValue', userCohortValue, {
          ...getCookieConfig({
            cookieName: 'deviceCohortValue',
            httpOnly: false,
            req
          })
        });
      }
      if(isMembershipPage){
      const userGroup = readCohortValueV1(userCohortValue, storeValue, 'subscription');
      return userGroup;
      }
      const userGroup = readCohortValueV1(userCohortValue, storeValue, 'cms');
      return userGroup;
    }
    return null;
  } catch (error) {
    console.log('Error from device Level Cohort API', error);
    
    return null;
  }

}

export function fetchLocalesWithUserType(customerTypeAPI, token, customerId, headerInfo) {
  return fetcher(
    customerTypeAPI,
    fetchGetJSONReqOpts({
      method: 'GET',
      headers: {
        ...(token ? { Authorization: `Bearer ${token}`, ...headerInfo } : null),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  )
    .then(fetchGetJSONResHandler)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return errorProcessor(error)
        .then(errorMessage => {
          ga.sendErrorToGA(error, errorMessage);
          return Promise.reject({
            status: error.status,
            errorMessage,
            error
          });

          // TODO-GA
        })
        .catch(errorInErrorObject => {
          ga.sendErrorInErrorToGA(error, errorInErrorObject);
        });
    });
}

export function isRuntimeBannersUrlEnabled(runtimeBannersUrlList, pageUri) {
  if (pageUri === '/shop/newCMSPreview') {
    return true;
  }
  if (!runtimeBannersUrlList || (runtimeBannersUrlList && runtimeBannersUrlList.length === 0)) {
    return true;
  }
  return runtimeBannersUrlList.includes(pageUri);
}

export function getStaticContent(response) {
  return _get(response, 'data.page.slots[0].component.banners[0].staticContent');
}

// res means response which will send

export function sendStaticContent({ res, content }) {
  const expires = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
  res.set({ Expires: new Date(expires).toGMTString() });
  res.send(content);
}

export function filterBannerSlots(slots) {
  const variant = getFeatureVariant('shopTheLook');
  if (variant !== '0') {
    return slots;
  }
  return slots.filter(slot => {
    const type = _get(slot, 'component.type');
    return type !== 'SHOPTHELOOK';
  });
}

export function getCategoryBannerRequestData(pageUrl, pageType, data) {
  const city = readCookie('CT') || '';
  const state = readCookie('ST') || '';
  const zone = readCookie('ZN') || '';
  const pincodeGroup = readCookie('PG') || '';

  const {
    metaData: { name } = {},
    flags: { earlyAccessEnabled, earlyAccessBannerCategory } = {}
  } = data;

  const enableUniversalCohortFlow = getAmplitudeVariantPayload('enableUniversalCohortFlow', data, false);
  const userGroup = readCohortValueCookie('userCohortValues', name, enableUniversalCohortFlow);
  const earlyAccessFlag = earlyAccessEnabled === 'ON';
  const earlyAccessBannerCategoryFlag = earlyAccessBannerCategory === 'ON';
  return {
    city,
    state,
    zone,
    pincodeGroup,
    userGroup,
    enableEarlyAccessFlag: earlyAccessFlag,
    enableEarlyAccessBannerCategoryFlag: earlyAccessBannerCategoryFlag,
    storeName: name,
    pageUrl,
    pageType
  };
}

export function formatDuration(time) {
  function pad2(number) {
    return (number < 10 ? '0' : '') + number;
  }

  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time - Number(minutes) * 60);
  return `${pad2(minutes)}:${pad2(seconds)}`;
}

export function redirectedFromVideoBanner() {
  // logic to check if redirected from video Banner
  const { href } = window.location;
  let hash = '';
  const hashIndex = href.indexOf('#');
  if (hashIndex > 0) hash = href.substring(hashIndex + 1);
  if (hash === 'VideoBanner') {
    return true;
  }
  return false;
}

export function redirectedFromFloatingWidget() {
  // logic to check if redirected from video Banner
  const { href } = window.location;
  let hash = '';
  const hashIndex = href.indexOf('#');
  if (hashIndex > 0) hash = href.substring(hashIndex + 1);
  if (hash === 'FloatingWidget') {
    return true;
  }
  return false;
}

function getBannerPositionStorageKey(type = 'WEB') {
  return type === 'WEB' ? 'webLandingPageScrollPosition' : 'msiteLandingPageScrollPosition';
}

function getBannerImpressionKey(type = 'WEB') {
  return type === 'WEB'
    ? 'bannerImpressionPromoIdDataListWeb'
    : 'bannerImpressionPromoIdDataListMsite';
}

function getJioAdsImpressionKey(type = 'WEB') {
  return type === 'WEB' ? 'jioAdsBannerPromoIdDataListWeb' : 'jioAdsBannerPromoIdDataListMsite';
}

function getProductWidgetKey(type = 'WEB') {
  return type === 'WEB' ? 'productWidgetDataListWeb' : 'productWidgetDataListMsite';
}

function getBundleBannerImpressionKey(type = 'WEB') {
  return type === 'WEB' ? 'bundleBannerImpressionPromoIdDataListWeb' : 'bundleBannerImpressionPromoIdDataListMsite';
}

export function removeBannerImpressionCookiesOnPageReloaded(type = 'WEB') {
  if (
    window?.performance &&
    performance?.navigation?.type == performance?.navigation?.TYPE_RELOAD
  ) {
    const storageKey = getBannerPositionStorageKey(type);
    const bannerKey = getBannerImpressionKey(type);
    const jioAdsKey = getJioAdsImpressionKey(type);
    const productWidgetKey = getProductWidgetKey(type);
    const bundleBannerKey = getBundleBannerImpressionKey(type);
    localStorage.removeItem(storageKey);
    localStorage.removeItem(bannerKey);
    localStorage.removeItem(jioAdsKey);
    localStorage.removeItem(productWidgetKey);
    localStorage.removeItem(bundleBannerKey);
  }
}

export function handleRemainingBundlePromotionImpression(type = 'WEB') {
  const bundleBannerKey = getBundleBannerImpressionKey(type);
  let { promotionArray = [], promotionData = {}} = getBundleBannerImpressionArray(bundleBannerKey, true) || {};
  if(promotionArray?.length > 0){
    const { storeType, pageName, pageType } = promotionData;
    gtmPromotionCmsImpressions(promotionArray, storeType, '', pageType)
    localStorage.removeItem(bundleBannerKey);
  }
}

export function setLandingPageScrollCookies(type = 'WEB') {
  const scrollPosition = window.scrollY || 0;
  const storageKey = getBannerPositionStorageKey(type);
  localStorage.setItem(storageKey, scrollPosition);
}

export function setLandingPageScroll(type = 'WEB') {
  setTimeout(() => {
    checkLandingPageScrolling(type);
  }, 2000);
}

function checkLandingPageScrolling(type = 'WEB') {
  const storageKey = getBannerPositionStorageKey(type);
  const landingPageScrollPosition = localStorage.getItem(storageKey);
  if (landingPageScrollPosition > 0) {
    const currentPosition = window.scrollY || 0;
    const startPosition = currentPosition - 20;
    const endPosition = currentPosition + 20;
    if (landingPageScrollPosition < startPosition || landingPageScrollPosition > endPosition) {
      window.scrollTo(0, landingPageScrollPosition);
    }
  }
  localStorage.removeItem(storageKey);
}
